import { FEATURE_LIMITS } from 'src/data/featureLimits';
import { PERFORMANCE_CHANNELS } from 'src/data/performance';
import {
  getCustomerPlan,
  getCustomerTier,
  isPlanFromBusinessCategory,
  isPlanFromBusinessOrEnterpriseCategory,
  MAX_SEAT_TIER,
} from 'src/data/subscription';
import { useCurrentCustomer } from 'src/store';

const shouldSkipDemoForFeature = (feature) =>
  [FEATURE_LIMITS.workspacesPerCustomer, FEATURE_LIMITS.membersPerCustomer].includes(feature);

export const useShouldCustomerBookDemoForFeature = ({ feature }) => {
  const currentCustomer = useCurrentCustomer();
  const plan = getCustomerPlan(currentCustomer);
  const tier = getCustomerTier(currentCustomer);

  const isBusiness = isPlanFromBusinessCategory(plan);
  const isBusinessOrEnterprise = isPlanFromBusinessOrEnterpriseCategory(plan);
  const skipDemoForFeature = shouldSkipDemoForFeature(feature);
  const isPerformanceChannel = PERFORMANCE_CHANNELS.includes(feature);

  const onHighestBusinessTier = isBusiness && tier === MAX_SEAT_TIER?.[plan];
  const onBusinessWithDemoableFeature = isBusiness && !skipDemoForFeature;

  return (
    onHighestBusinessTier ||
    onBusinessWithDemoableFeature ||
    isBusinessOrEnterprise ||
    isPerformanceChannel
  );
};
